/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class LockConfigDetailsSortCriteria {
    getFixupPrototypeFunction() { return LockConfigDetailsSortCriteria.fixupPrototype; }

    static newInstance(model: Partial<LockConfigDetailsSortCriteria>): LockConfigDetailsSortCriteria {
        let obj = Object.assign(new LockConfigDetailsSortCriteria(), model);
        LockConfigDetailsSortCriteria.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<LockConfigDetailsSortCriteria>): LockConfigDetailsSortCriteria {
        if (!model) return null;
        return LockConfigDetailsSortCriteria.newInstance(<LockConfigDetailsSortCriteria> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: LockConfigDetailsSortCriteria) {
        if (!obj) return;

        models.LockConfigDetailsSortCriteria.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: LockConfigDetailsSortCriteria): boolean {
        Object.setPrototypeOf(obj, LockConfigDetailsSortCriteria.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    column: models.LockConfigDetailsSortColumn;

    ascending: boolean;

}
